export default __webpack_public_path__ + "static/media/homeImg.df4185cb.png";